'use strict';
const angular = require('angular');

export class addPropertyContactComponent {
  constructor(ContactService, $uibModal, SettingsService) {
    'ngInject';

    this.$uibModal = $uibModal;
    this.ContactService = ContactService;

    let states_us = ["AL", "AK", "AS", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FM", "FL", "GA", "GU", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MH", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "MP", "OH", "OK", "OR", "PW", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VI", "VA", "WA", "WV", "WI", "WY"];
    let states_can = ["AB", "BC", "MB", "NB", "NL", "NT", "NS", "NU", "ON", "PE", "QC", "SK", "YT"];

    this.states = [].concat(
      states_us.map(state => {
        return {country: 'United States', state: state}
      }),
      states_can.map(state => {
        return {country: 'Canada', state: state}
      }),
      [{country: 'Other', state: 'XX'}]
    );

    SettingsService.getByName({name: 'config.app'}, appSettings => {
      this.phoneTypes = appSettings.data.phoneTypes;
      this.mailTypes = appSettings.data.mailTypes;
      this.addressTypes = appSettings.data.addressTypes;
      this.socialTypes = appSettings.data.socialTypes;

      this.contact = {
        phone: [{
          type: this.phoneTypes[0],
          isPrimary: true
        }],
        address: [{
          type: this.addressTypes[0],
          isPrimary: true
        }],
        email: [{
          type: this.mailTypes[0],
          isPrimary: true
        }]
      };
    });

    this.contactTypes = [{
      value: "primary-owner",
      name: "Primary Owner"
    },{
      value: "owner",
      name: "Owner"
    },{
      value: "previous-owner",
      name: "Previous Owner"
    },{
      value: "renter",
      name: "Renter"
    },{
      value: "visitor",
      name: "Visitor"
    }];

    ContactService.query(data => {
      this.contacts = data.map(contact => {
        return {
          value: contact._id,
          name: this.getComposedName(contact)
        };
      });
    });
  }

  $onInit = function () {
    this.config = this.resolve.config;
    this.contactEntry = {
      type: this.config.type || 'owner'
    };
  };

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += " (" + contact.company + ")";
    }

    return composedName || "-";
  }

  contactLookup(contact) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'contactLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      (contact) => {
        this.contactEntry.contact = contact._id;
      },
      function () { /* cancel */ }
    );

  }

  ok() {
    if (this.activeTab == 1) {  // If "New Contact" we have to create it first then assign the id to the contact

      // some cleanup
      if (!this.contact.phone[0].number)
        delete this.contact.phone;

      if (!this.contact.email[0].address)
        delete this.contact.email;

      if (!this.contact.address[0].street && !this.contact.address[0].city)
        delete this.contact.address;

      // save it
      this.ContactService.save(this.contact, newContact => {
        this.contactEntry.contact = newContact._id;
        this.close({$value: this.contactEntry});
      }, _ => {
        console.log("There has been an error trying to create a new owner as contact");
      });
    } else {
      this.close({$value: this.contactEntry});
    }
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  openDatePopup(ctx) {
    if (ctx == 'from')
      this.fromOpened = true;
    else
      this.tillOpened = true;
  }
}

export default angular.module('conduuApp.addPropertyContact', [])
  .component('addPropertyContact', {
    template: require('./add-property-contact.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: addPropertyContactComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/add-property-contact/add-property-contact.component.js